














































import BaseFormMixin from '@/mixins/base-form-mixin';
import { DatasourceDto } from '@/services/datasource';
import { mixins } from 'vue-class-component';
import { Component, PropSync, Watch } from 'vue-property-decorator';

@Component
export default class DsConfForm extends mixins(BaseFormMixin) {
  @PropSync('formData') syncFormData!: DatasourceDto;

  mounted() {
    this.syncFormData.dsConfig = {
      dbInstance: '',
      ipAddr: '',
      port: '',
      username: '',
      password: '',
      propsInput: '',
      properties: [],
      // 0：启用，1：禁用
      useSSL: 1
    };
  }

  @Watch('syncFormData', { deep: true })
  onDataChange() {
    let fd = this.syncFormData.dsConfig;
    let dsType = this.syncFormData.dsType.toLowerCase();
    if (fd) {
      let useSSLStr = (fd.useSSL === 0) ? 'useSSL=true' : 'useSSL=false';
      this.syncFormData.dsConfig.url = 'jdbc:' + dsType + '://' + fd.ipAddr + ':' + fd.port + '/' + fd.dbInstance + '?useUnicode=true&characterEncoding=UTF-8&' + useSSLStr;
    }
  }
}
